import React, {useEffect, useState} from 'react'
import {Button, message, Modal, Table} from "antd"
import {getTopUpHistory} from "../../../../../../services/api/apiCustomerHub"
import parseToken from "../../../../../../helpers/parseToken"
import moment from "moment"

const HistoryFeeModal = (props) => {
    const decodeToken = parseToken()
    const {custId} = props

    const [isOpen, setIsOpen] = useState(false)
    const [listHistoryFee, setListHistoryFee] = useState([])
    const [pager] = useState({
        page: 1,
        limit: 10,
    })

    const _onShowModal = () => {
        setIsOpen(true)
    }

    const _onCancel = () => {
        setIsOpen(false)
    }

    const columns = [
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Nguười nạp',
            dataIndex: 'actionBy',
            key: 'actionBy',
        },
        {
            title: 'Thời gian',
            dataIndex: 'actionAt',
            key: 'actionAt',
            render: (text) => {
                return text && moment(text).format('DD/MM/YYYY')
            }
        }
    ]

    const _fetchListHistoryFee = async () => {
        try {
            const response = await getTopUpHistory(decodeToken.sub, pager, custId)

            const {success, error_message, data} = response
            if (success !== '1') {
                return message.error(error_message)
            }

            setListHistoryFee(data)
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            _fetchListHistoryFee()
        }
        // eslint-disable-next-line
    }, [isOpen, JSON.stringify(pager)])

    return (
        <div className="HistoryFeeModal">
            <Button type='primary' onClick={_onShowModal}>Lịch sử nạp cước</Button>
            <Modal
                title="Lịch sử nạp cước"
                className={`ModalCustom2`}
                style={{top: 20}}
                maskClosable={false}
                open={isOpen}
                onCancel={_onCancel}
                footer={[
                    <Button key="back" type="default" onClick={_onCancel}>
                        Cancel
                    </Button>
                ]}
            >
                <div className="FormAddNew">
                    <Table
                        columns={columns}
                        dataSource={listHistoryFee}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default HistoryFeeModal
